import { render } from "./FleetRides.vue?vue&type=template&id=507cc5d4"
import script from "./FleetRides.vue?vue&type=script&lang=js"
export * from "./FleetRides.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CTS_SURAJ\\MAHASBM\\MAHASBM-CODE\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__